import clsx from 'clsx'

type Props = {
    icon: JSX.Element
    buttonClassName?: string
    variant?: 'default' | 'compact'
}

/**
 * Loading indicator for actions.
 */
export default function ActionLoading(props: Props) {
    const { icon, buttonClassName, variant = 'default' } = props
    // The compact variant trims the spinner so it fits inside split buttons like Cross Profile Engage.

    const spinnerPositionClasses = clsx('absolute left-0 top-0', variant === 'compact' && '-left-px -top-px')

    const spinnerClasses = clsx(
        'text-gray-400',
        'inline-block align-[-0.125em]',
        'rounded-full border-solid border-current border-r-transparent',
        'animate-spin motion-reduce:animate-[spin_1.5s_linear_infinite]',
        variant === 'compact' ? 'h-[42px] w-[42px] border text-gray-300' : 'h-10 w-10 border-2'
    )

    return (
        <div className="h-10 w-10">
            <div className={clsx('btn-icon relative text-gray-400', buttonClassName)}>{icon}</div>
            <div className={spinnerPositionClasses}>
                <div className={spinnerClasses} role="status">
                    <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                        Loading...
                    </span>
                </div>
            </div>
        </div>
    )
}
